<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="true" granularity="day" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import areaChartOptions from "@/config/charts/area";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null,
      selectedPhaseLocal: null,
      phases: ["L1", "L2", "L3"]
    };
  },
  computed: {
    selectedPhase() {
      return this.$store.getters.getSettings.phase;
    },
    selectedyAxisType() {
      return this.$store.getters.getSettings.yAxisType;
    }
  },

  created() {
    const onyAxisSelect = type => {
      this.$store.commit("setyAxisType", type);
    };

    this.chartOptions = JSON.parse(JSON.stringify(areaChartOptions));
    this.chartOptions.title.text = this.$lang.charts.voltage_profile;
    this.chartOptions.yAxis.labels.format = "{value} V";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} V</b><br/>";

    this.chartOptions.yAxis.type = "logarithmic";
    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.chartOptions.exporting.buttons.contextButton.menuItems.push(
      "separator"
    );

    this.chartOptions.exporting.buttons.contextButton.menuItems.push({
      textKey: "scalerChange",
      onclick: function() {
        if (this.userOptions.yAxis.type == "logarithmic") {
          this.userOptions.yAxis.type = "linear";
          this.yAxis[0].update({ type: "linear" });
          onyAxisSelect("linear");
        } else {
          this.userOptions.yAxis.type = "logarithmic";
          this.yAxis[0].update({ type: "logarithmic" });
          onyAxisSelect("logarithmic");
        }
      }
    });
  },

  methods: {
    onPanelSelect(data) {
      this.$nextTick(() => {
        this.getAPIData(data);
      });
    },

    getAPIData(selected) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      const onPhaseSelect = (phase, visibility) => {
        this.selectedPhaseLocal = this.selectedPhase;
        this.selectedPhaseLocal[phase] = !visibility;
        this.$store.commit("setSelectedPhase", this.selectedPhaseLocal);
      };

      while (chart.series.length > 0) {
        chart.series[0].remove(false, false);
      }
      this.chartOptions.series = [];

      for (let i = 0; i < selected.device.phase_use; i++) {
        this.chartOptions.series.push({
          name: this.$lang.charts.phase + " " + this.phases[i],
          type: "area",
          visible: this.selectedPhase[this.phases[i]],
          marker: {
            enabled: false
          },
          events: {
            legendItemClick: function(event) {
              onPhaseSelect(this.phases[i], event.target.visible);
            }.bind(this)
          },
          data: []
        });
      }

      if (selected.device.phase_use > 1) {
        this.chartOptions.series.push({
          name: this.$lang.charts.average,
          type: "area",
          visible: this.selectedPhase.AVG,
          marker: {
            enabled: false
          },
          events: {
            legendItemClick: function(event) {
              onPhaseSelect("AVG", event.target.visible);
            }.bind(this)
          },
          data: []
        });
      }

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + ( (selected.device.type === 12) ? "/profileEY" : "/profile"),
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          data: "U",
          phase: "L1,L2,L3",
          from: selected.date.from,
          to: selected.date.to,
          cumulative: true,
          format: "H",
          source: selected.source
        },
        withCredentials: true
      })
        .then(response => {
          console.log(selected.device);
          for (let i = 0; i < selected.device.phase_use; i++) {
            chart.series[i].setData(
              response.data.data.U[this.phases[i]],
              false,
              false,
              false
            );
          }
          if (selected.device.phase_use > 1) {
            chart.series[selected.device.phase_use].setData(
              response.data.data.U.cumulative,
              false,
              false,
              false
            );
          }

          chart.xAxis[0].setExtremes(null, null, true);
        })
        .catch(error => {
          if (error.response.data.code == 610) {
            this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
            for (let i = 0; i < selected.device.phase_use; i++) {
              chart.series[i].setData([]);
            }
            if (selected.device.phase_use > 1) {
              chart.series[selected.device.phase_use].setData([]);
            }
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>